import { render, staticRenderFns } from "./SalesAssignment.vue?vue&type=template&id=403a78ae&scoped=true&"
import script from "./SalesAssignment.vue?vue&type=script&lang=js&"
export * from "./SalesAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a78ae",
  null
  
)

export default component.exports